import { getMessageTemplatesApi } from '@/core/api/generatedApiClient';
import { rethrowHandledApiError } from '@/core/api/rethrowHandledApiError';
import type {
    ApiMessageTemplateGroup,
    ApiMessageTemplateGroupSimpleModel,
    MessageTemplateResponse,
    UpdateMessageTemplateRequest,
} from '@/core/generated/api';

/** Выполняет операции с текстовками приложения */
export const messageTemplateService = {
    /** Загружает группы текстовок */
    async getGroups(): Promise<ApiMessageTemplateGroupSimpleModel[]> {
        try {
            const response = await getMessageTemplatesApi().apiV1MessageTemplatesGroupsGet();

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Загружает тексты выбранной группы */
    async getByGroup(group: ApiMessageTemplateGroup): Promise<MessageTemplateResponse[]> {
        try {
            const response = await getMessageTemplatesApi().apiV1MessageTemplatesGet({ group });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Загружает одну текстовку */
    async getById(id: string): Promise<MessageTemplateResponse> {
        try {
            const response = await getMessageTemplatesApi().apiV1MessageTemplatesIdGet({ id });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Сохраняет текст и пояснение */
    async update(id: string, request: UpdateMessageTemplateRequest): Promise<void> {
        try {
            await getMessageTemplatesApi()
                .apiV1MessageTemplatesIdPut({
                    id,
                    updateMessageTemplateRequest: request,
                });
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },
};
